import { z } from "zod";

export const UsersSearchParamsSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  search: z.string().optional(),
});

export type UsersSearchParams = z.infer<typeof UsersSearchParamsSchema>;
